import { mkSiteBuilderComponent } from "@discovery/template-engine/lib/component-map";
import PricePlanView from "./price-plan-view";
const getProps = (data) => {
    return { data };
};
const PricePlan = ({ environment, data, }) => {
    return (React.createElement(React.Suspense, { fallback: () => React.createElement(React.Fragment, null) },
        React.createElement(PricePlanView, { data: data, read: environment })));
};
export const ComponentMapItem = mkSiteBuilderComponent(getProps, PricePlan);

